export default function officesPageScript() {
    const lightbox = document.querySelector<HTMLElement>('[data-gallery-lightbox]');
    const lightboxImage = document.querySelector<HTMLImageElement>('[data-gallery-lightbox-image]');
    const closeButton = document.querySelector<HTMLButtonElement>('[data-gallery-close]');
    const galleryItems = Array.from(document.querySelectorAll<HTMLButtonElement>('[data-gallery-image]'));

    if (!lightbox || !lightboxImage || !closeButton || !galleryItems.length) return;

    const galleryLightbox = lightbox;
    const galleryLightboxImage = lightboxImage;
    const galleryCloseButton = closeButton;
    let activeTrigger: HTMLButtonElement | null = null;

    function closeLightbox() {
        galleryLightbox.hidden = true;
        galleryLightboxImage.src = '';
        galleryLightboxImage.alt = '';
        document.body.classList.remove('gallery-lightbox-open');
        activeTrigger?.focus();
        activeTrigger = null;
    }

    function openLightbox(trigger: HTMLButtonElement) {
        const imageSource = trigger.dataset.galleryImage;

        if (!imageSource) return;

        activeTrigger = trigger;
        galleryLightboxImage.src = imageSource;
        galleryLightboxImage.alt = trigger.dataset.galleryAlt ?? '';
        galleryLightbox.hidden = false;
        document.body.classList.add('gallery-lightbox-open');
        galleryCloseButton.focus();
    }

    galleryItems.forEach((item) => {
        item.addEventListener('click', () => openLightbox(item));
    });

    galleryCloseButton.addEventListener('click', closeLightbox);

    galleryLightbox.addEventListener('click', (event) => {
        if (event.target === galleryLightbox) {
            closeLightbox();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && !galleryLightbox.hidden) {
            closeLightbox();
        }
    });
}
